import React from 'react';
import PropTypes from 'prop-types';
import { OrderSample } from '@one-thd/sui-icons';

const SlabViewCallout = ({ slabDictionaryTerm }) => {
  return (
    <div style={{ display: 'flex' }} className="fusion-slot sui-bg-primary sui-p-3 sui-mb-3">
      <OrderSample size="large" style={{ minHeight: 35, minWidth: 35, margin: '1rem' }} />
      <div style={{ minHeight: 50 }} className="summary-background-alt">
        <span className="!sui-p-0 sui-text-base sui-leading-normal sui-font-regular">
          {slabDictionaryTerm}
        </span>
      </div>
    </div>
  );
};

SlabViewCallout.propTypes = {
  slabDictionaryTerm: PropTypes.string.isRequired,
};

export default SlabViewCallout;